import React from "react";
import svgUrl from "/Users/mrp/Documents/XSwapProtocol/v3-swap/src/assets/images/blue-loader.svg?url";
const SvgBlueLoader = (props) => /* @__PURE__ */ React.createElement("svg", {
  width: 94,
  height: 94,
  viewBox: "0 0 94 94",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M92 47C92 22.1472 71.8528 2 47 2C22.1472 2 2 22.1472 2 47C2 71.8528 22.1472 92 47 92",
  stroke: "#5F60D4",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
export {SvgBlueLoader as ReactComponent};
export default svgUrl;
